module.exports = __webpack_public_path__ + "static/media/ole-logo.ff922963.png";